/**
 * Brevo newsletter subscription utility
 * Adds a contact to the Brașov Gateway Newsletter list (ID: 3)
 * and triggers the welcome email automation.
 */

const BREVO_API_KEY = "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";
const BREVO_LIST_ID = 3;

export async function subscribeToNewsletter(email: string): Promise<void> {
  const response = await fetch("https://api.brevo.com/v3/contacts", {
    method: "POST",
    headers: {
      "accept": "application/json",
      "content-type": "application/json",
      "api-key": BREVO_API_KEY,
    },
    body: JSON.stringify({
      email,
      listIds: [BREVO_LIST_ID],
      updateEnabled: true, // if contact already exists, add them to the list
    }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    // 204 = already exists and updated — treat as success
    if (response.status === 204) return;
    throw new Error(data?.message || `Brevo API error: ${response.status}`);
  }
}
